import { useParams } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import { Fragment, useLayoutEffect, useState, useEffect } from "react";
import { CustomGetAPI } from "../Utils/APIConnector";
import {
  convertTo12HourFormat,
  venueAmenitiesData,
  VenueDate,
  venueSportsData,
} from "../Utils/common";
import Loader from "../Utils/Loader";
import UseModal from "../Utils/PopupModal/UseModal";
import ClaimVenueModal from "../Utils/PopupModal/ClaimVenueModal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function ClaimVenue() {
  const { venueName } = useParams();
  const [loader, setLoader] = useState(false);
  const [DataError, setClaimedStatus] = useState(0);
  const [ClaimNowModal, setClaimNowModal] = useState({
    modalNo: 0,
    isModalOpen: false,
  });
  const [venueData, setVenueData] = useState([]);
  const [selectedCourtIndex, setSelectedCourtIndex] = useState(0);
  const venueModalRaw = { id: venueData.id, venueName: venueData.name };

  async function fetchData() {
    setLoader(true);
    await CustomGetAPI(`/venue/GetClaimVenueDetails/${venueName}`).then(
      (result) => {
        if (result) {
          result = JSON.parse(result);
          if (result.status === "Success") {
            setVenueData(result?.venueDetails);
            setLoader(false);
            setClaimedStatus(1);
          } else if (result.status === "Claimed") {
            setLoader(false);
            setClaimedStatus(0);
          } else {
            setLoader(false);
            setClaimedStatus(2);
          }
        }
      }
    );
  }
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, [venueName]);

  const handlePopUp = (modalNo, isModalOpen) => {
    setClaimNowModal({ modalNo: modalNo, isModalOpen: isModalOpen });
  };
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    waitForAnimate: false,
    rtl: false,
  };
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Fragment>
      {!loader ? (
        <>
          {DataError === 1 ? (
            <div className="px-md-5 px-2">
              <div className="row">
                <div className="col-12 ps-md-4 d-flex align-items-center">
                  <div className="row w-100 claimNowAnimate-bg mt-3 mx-0">
                    <div className="col-12 col-lg-10 text-white px-0 d-flex align-items-center justify-content-center justify-content-lg-start">
                      <div className="d-flex flex-column mb-lg-0 mb-md-3 mb-0">
                        <label className="d-flex Montserrat fw-500 mb-3 mb-md-0 text-center text-lg-end">
                          We have received several booking requests for your
                          venue online
                          <span className="d-md-block d-none">,</span>
                        </label>
                        <label className="d-md-block d-none Montserrat fw-500">
                          Claim your venue and grow your bookings!
                        </label>
                      </div>
                    </div>
                    <div
                      className="mx-auto col-6 col-lg-2 claim-button"
                      onClick={() => handlePopUp(2, true)}
                      style={{ rotate: "180deg" }}
                    >
                      <Slider {...settings}>
                        <button className="claim-button-white d-flex align-items-center justify-content-center">
                          Claim Now{" "}
                          <img
                            className="ms-2"
                            src="/images/arrow1.svg"
                            alt="arrow"
                            style={{
                              transform: "rotate(180deg)",
                              width: "16px",
                              height: "16px",
                              filter:
                                "invert(49%) sepia(77%) saturate(734%) hue-rotate(327deg) brightness(92%) contrast(93%)",
                            }}
                          />
                        </button>
                        <button className="claim-button-red d-flex align-items-center justify-content-center">
                          Claim Now{" "}
                          <img
                            className="ms-2"
                            src="/images/arrow1.svg"
                            alt="arrow"
                            style={{
                              transform: "rotate(180deg)",
                              width: "16px",
                              height: "16px",
                              marginLeft: "6px",
                              filter: "invert(100%) brightness(300%)",
                            }}
                          />{" "}
                        </button>
                      </Slider>
                    </div>
                    {/* <button
                        className="ms-3 text-nowrap fw-600 Montserrat"
                    
                      >
                        Claim Now
                      </button> */}
                  </div>
                </div>
                <div className="col-lg-4 my-3">
                  {width < 768 && venueData?.venuebookings?.length > 0 && (
                    <>
                      <div
                        className="newdiv pt-0 mb-3"
                        style={{ border: "2px solid rgb(231, 102, 106)" }}
                      >
                        <>
                          <div className="courtNameDiv p-3">
                            <h1 class="fade-text">Recent booking inquires</h1>
                          </div>
                          <div className="row mt-2 px-3">
                            <div
                              className="col-12 col-lg-12 my-2"
                              style={{
                                maxHeight: "30vh",
                                overflowY: "auto",
                              }}
                            >
                              {venueData?.venuebookings?.map(
                                (booking, index) => (
                                  <>
                                    <div className="row">
                                      <div className="col-md-6 col-6">
                                        Sport: {booking?.name}
                                      </div>
                                      <div className="col-md-6 col-6 text-end">
                                        Date:{" "}
                                        {
                                          VenueDate(booking?.date)
                                            ?.formattedDate
                                        }
                                      </div>
                                      <div className="col-md-5 col-5 mt-2">
                                        Time:{" "}
                                        {convertTo12HourFormat(
                                          booking?.startTime
                                        )}
                                      </div>
                                      <div className="col-md-7 col-7 mt-2 text-end">
                                        Phone No.: {booking?.userPhone}
                                      </div>
                                    </div>
                                    {venueData?.venuebookings?.length !==
                                      index + 1 && <hr />}
                                  </>
                                )
                              )}
                            </div>
                          </div>
                        </>
                      </div>
                      <div className="mt-4 gap-3 d-flex claimNowDiv justify-content-center">
                        <label
                          className="Montserrat"
                          onClick={() => handlePopUp(3, true)}
                        >
                          Don’t want to list venue Let us know
                          <img
                            className="ms-2"
                            src="/images/click-here.png"
                            alt=""
                            srcset=""
                          />
                        </label>
                      </div>
                    </>
                  )}
                </div>

                <div className="Container px-3">
                  <div className="row mt-1 px-2">
                    <div className="col-lg-8 my-3">
                      <div className="position-relative">
                        <Carousel controls={true} indicators={false}>
                          {venueData?.venueImage?.map((data, i) => (
                            <Carousel.Item className="Carousel-radius" key={i}>
                              <img
                                src={data}
                                className="venuePhotos3"
                                alt="image"
                              />
                            </Carousel.Item>
                          ))}
                        </Carousel>
                        <button
                          className="googlemapButton d-flex align-items-center"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          <img
                            src="/images/GoogleMap-new.svg"
                            alt=""
                            className="cursor-pointer"
                          />
                          <span
                            className="ms-1 d-none d-md-block"
                            style={{ color: "#818181", fontSize: "12px" }}
                          >
                            Open in Google Map
                          </span>
                        </button>
                      </div>
                      <div className="row mt-3">
                        <div className="col-lg-12 venuePlaceName mt-3">
                          <div className="row">
                            <div
                              className="col-12 d-flex flex-md-row flex-column-reverse justify-content-between align-items-md-center"
                              style={{ color: "black" }}
                            >
                              <div className="d-flex">
                                {" "}
                                <h1
                                  style={{
                                    fontSize: "22px",
                                    fontWeight: "600",
                                  }}
                                  className="mb-0 mt-md-0 mt-2"
                                >
                                  {venueData?.name}
                                </h1>
                              </div>
                              <div className="d-flex gap-2">
                                {venueData?.venueSports &&
                                  venueData?.venueSports.map((sports) => (
                                    <div
                                      className="d-flex align-items-center rounded-pill border px-3 py-1 fw-400"
                                      style={{ color: "#00000080" }}
                                    >
                                      <img
                                        src={`/images/${venueSportsData(
                                          sports?.name
                                        )}`}
                                        alt={sports?.name}
                                        className="me-2"
                                        height={20}
                                        width={20}
                                      />
                                      <label className="fs-6">
                                        {sports.name}
                                      </label>
                                    </div>
                                  ))}
                              </div>
                            </div>

                            <div className="col-lg-8 col-12 mt-2 fw-400 text-black fs-6">
                              {venueData?.address}
                            </div>

                            <div className="col-12 mt-3">
                              <label className="text-black fw-600 fs-6">
                                Operating Hours :
                              </label>{" "}
                              <br />
                              <label className="text-black fw-400 fs-6">
                                <img
                                  className="img-fluid me-1"
                                  src="/images/black-clock.svg"
                                  alt=""
                                />
                                24 Hrs
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-4">
                        <h2 className="venueText fs-6 fw-600">
                          Amenities Available :
                        </h2>
                        <div className="surface-items">
                          <div className="row">
                            {venueData?.venueAmenity &&
                              venueData?.venueAmenity?.map(
                                (amenities, index) => (
                                  <div className="col-6 col-md-3" key={index}>
                                    <div
                                      className={`text-nowrap my-2 ${
                                        venueData?.venueAmenity?.length - 1 !==
                                        index
                                          ? "border-end"
                                          : ""
                                      }`}
                                    >
                                      <img
                                        src={`/images/${venueAmenitiesData(
                                          amenities
                                        )}`}
                                        alt=""
                                        height={22}
                                        width={22}
                                      />
                                      <span className="ps-2 fs-6">
                                        {amenities}
                                      </span>
                                    </div>
                                  </div>
                                )
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 my-3">
                      {width > 768 && venueData?.venuebookings?.length > 0 && (
                        <>
                          <div className="mb-4 gap-3 d-flex claimNowDiv justify-content-center">
                            <label
                              className="Montserrat"
                              onClick={() => handlePopUp(3, true)}
                            >
                              Don’t want to list venue Let us know
                              <img
                                className="ms-2"
                                src="/images/click-here.png"
                                alt=""
                                srcset=""
                              />
                            </label>
                          </div>
                          <div
                            className="newdiv pt-0 mb-3"
                            style={{ border: "2px solid rgb(231, 102, 106)" }}
                          >
                            <>
                              <div className="courtNameDiv p-3">
                                <h1 class="fade-text">
                                  Recent booking inquires
                                </h1>
                              </div>
                              <div className="row mt-2 px-3">
                                <div
                                  className="col-12 col-lg-12 my-2"
                                  style={{
                                    maxHeight: "30vh",
                                    overflowY: "auto",
                                  }}
                                >
                                  {venueData?.venuebookings?.map(
                                    (booking, index) => (
                                      <>
                                        <div className="row">
                                          <div className="col-md-6 col-6">
                                            Sport: {booking?.name}
                                          </div>
                                          <div className="col-md-6 col-6 text-end">
                                            Date:{" "}
                                            {
                                              VenueDate(booking?.date)
                                                ?.formattedDate
                                            }
                                          </div>
                                          <div className="col-md-5 col-5 mt-2">
                                            Time:{" "}
                                            {convertTo12HourFormat(
                                              booking?.startTime
                                            )}
                                          </div>
                                          <div className="col-md-7 col-7 mt-2 text-end">
                                            Phone No.: {booking?.userPhone}
                                          </div>
                                        </div>
                                        {venueData?.venuebookings?.length !==
                                          index + 1 && <hr />}
                                      </>
                                    )
                                  )}
                                </div>
                              </div>
                            </>
                          </div>
                        </>
                      )}

                      <div className="newdiv pt-0">
                        <>
                          <div className="courtNameDiv p-3">
                            <ul className="nav nav-underline custom-nav-underline justify-content-center align-items-center">
                              {venueData?.courtData?.value?.data?.map(
                                (court, index) => (
                                  <Fragment>
                                    <li className={`nav-item courtnameText`}>
                                      <a
                                        className={`nav-link ${
                                          selectedCourtIndex === index
                                            ? "active"
                                            : ""
                                        }`}
                                        onClick={() =>
                                          setSelectedCourtIndex(index)
                                        }
                                      >
                                        {court?.courtname}
                                      </a>
                                    </li>
                                    {index !==
                                      venueData?.courtData?.value?.data
                                        ?.length -
                                        1 && <span className="mb-1">|</span>}
                                  </Fragment>
                                )
                              )}
                            </ul>
                          </div>

                          <div>
                            <div className="row mt-2 px-3">
                              <div className="col-8  d-flex mx-0 justify-content-between row">
                                {venueData?.courtData?.value?.data[
                                  selectedCourtIndex
                                ]?.sport?.map((sportData, sportIndex) => (
                                  <div
                                    key={sportIndex}
                                    className="d-flex align-items-center p-2 my-2 w-auto justify-content-center"
                                    style={{
                                      border: "1px solid #D2D2D2",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    <img
                                      src={`/images/${venueSportsData(
                                        sportData?.name
                                      )}`}
                                      alt={sportData?.name}
                                      className="sportsAmenities me-1 fs-12"
                                    />
                                    <span className="courtnameText fw-400 fs-12">
                                      {sportData?.name}
                                    </span>
                                  </div>
                                ))}
                              </div>
                              <div className="col-4 p-0">
                                <div className="row">
                                  <div className="col-12">
                                    <span className="courtnameText fw-700">
                                      Max Capacity
                                    </span>
                                  </div>
                                  <div className="col-12 ">
                                    <label className="courtnameText fw-400">
                                      (
                                      {
                                        venueData?.courtData?.value?.data[
                                          selectedCourtIndex
                                        ].maxcapacity
                                      }
                                      <img src="/images/peopleicon.svg" />)
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row mt-2 px-3">
                              <div className="col-12 col-md-12">
                                {venueData?.courtData?.value?.data[
                                  selectedCourtIndex
                                ]?.weekDay?.map((weekday, i) => (
                                  <div className="" key={i}>
                                    {weekday?.data[0]?.rehearsal && (
                                      <>
                                        <span className="courtnameText fw-700">
                                          <b className="text-danger">
                                            Rehearsal Price
                                          </b>
                                        </span>
                                        <br />
                                      </>
                                    )}
                                    <span className="courtnameText fw-700">
                                      {weekday?.weekDays}
                                    </span>
                                    <br />
                                    {weekday?.data?.map((item, i) => {
                                      return (
                                        <div className="mt-2" key={item?.id}>
                                          {venueData?.courtData?.value?.data[
                                            selectedCourtIndex
                                          ]?.sport[0]?.name === "Go-Karting" ? (
                                            <>
                                              {item?.duration1 != null && (
                                                <>
                                                  <label className="courtnameText fw-400 mb-3">
                                                    5 Min
                                                  </label>
                                                  <b className="courtPrice float-end">
                                                    ₹ {item?.duration1}
                                                  </b>
                                                  <br />
                                                </>
                                              )}
                                              {item?.duration2 != null && (
                                                <>
                                                  <label className="courtnameText fw-400 mb-3">
                                                    10 Min
                                                  </label>
                                                  <b className="courtPrice float-end">
                                                    ₹ {item?.duration2}
                                                  </b>
                                                  <br />
                                                </>
                                              )}
                                              {item?.duration3 != null && (
                                                <>
                                                  <label className="courtnameText fw-400 mb-3">
                                                    15 Min
                                                  </label>
                                                  <b className="courtPrice float-end">
                                                    ₹ {item?.duration3}
                                                  </b>
                                                  <br />
                                                </>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              <div className="d-flex justify-content-between">
                                                <div className="mb-3">
                                                  <label className="courtnameText fw-400 ">
                                                    (
                                                    {convertTo12HourFormat(
                                                      item?.startTime
                                                    ) === "12:00 am" &&
                                                    convertTo12HourFormat(
                                                      item?.endTime
                                                    ) === "12:00 am"
                                                      ? "24 Hours"
                                                      : `${convertTo12HourFormat(
                                                          item?.startTime
                                                        )} - ${convertTo12HourFormat(
                                                          item?.endTime
                                                        )}`}
                                                    )
                                                  </label>
                                                  <div className="courtnameText">
                                                    Advance Amount
                                                  </div>
                                                </div>
                                                <div className="">
                                                  <b className="courtPrice">
                                                    ₹ {item?.amount}/hr
                                                  </b>
                                                  <br />
                                                  <b className="courtPrice float-end">
                                                    {item?.bookingAmount}%
                                                  </b>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      );
                                    })}
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                      <div className="mt-4 gap-3 d-flex claimNowDiv flex-md-row flex-column-reverse align-items-stretch align-items-md-center justify-content-md-end justify-content-center">
                        <label
                          className="Montserrat"
                          onClick={() => handlePopUp(1, true)}
                        >
                          Incorrect Details Contact Us
                        </label>
                        <button
                          className="Montserrat"
                          onClick={() => handlePopUp(2, true)}
                        >
                          Claim Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {DataError === 0 ? (
                <div className="container">
                  <h1>The venue you have searched is already been claimed</h1>
                </div>
              ) : (
                <div className="container">
                  <h1>No Venue Found</h1>
                </div>
              )}
            </>
          )}
        </>
      ) : (
        <Loader mt={"15%"} />
      )}

      {ClaimNowModal.modalNo === 1 && ClaimNowModal.isModalOpen && (
        <UseModal
          isModalOpen={ClaimNowModal.isModalOpen}
          component={
            <ClaimVenueModal
              BtnText={"Contact Us"}
              VenueDetails={venueModalRaw}
              handlePopUp={handlePopUp}
              isClaimClick={false}
            />
          }
          handlePopUp={handlePopUp}
          heading={"Incorrect Details Contact us"}
          footer={""}
        />
      )}
      {ClaimNowModal.modalNo === 2 && ClaimNowModal.isModalOpen && (
        <UseModal
          isModalOpen={ClaimNowModal.isModalOpen}
          component={
            <ClaimVenueModal
              BtnText={"Send"}
              VenueDetails={venueModalRaw}
              handlePopUp={handlePopUp}
              isClaimClick={true}
            />
          }
          handlePopUp={handlePopUp}
          heading={"Claim your listing details"}
          footer={""}
        />
      )}
      {ClaimNowModal.modalNo === 3 && ClaimNowModal.isModalOpen && (
        <UseModal
          isModalOpen={ClaimNowModal.isModalOpen}
          component={
            <ClaimVenueModal
              BtnText={"Send"}
              VenueDetails={venueModalRaw}
              handlePopUp={handlePopUp}
              isClaimClick={false}
              notInterested={true}
            />
          }
          handlePopUp={handlePopUp}
          heading={"Don’t want to list venue Let us know"}
          footer={""}
        />
      )}
    </Fragment>
  );
}
